import { render } from "./Mapping.vue?vue&type=template&id=f43e5b84&scoped=true"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"

import "./Mapping.vue?vue&type=style&index=0&id=f43e5b84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43e5b84"]])

export default __exports__